import styled from 'styled-components'

export const StyledImgButton = styled.img`
  cursor: pointer;
  vertical-align: middle;
`
